import React, { Component } from "react";
import Radium from "radium";
import { connect } from "react-redux";
import Waves from "node-waves";
import { Scrollbars } from "react-custom-scrollbars";
import auth from "../../../Login/authService";
import { httpGet, httpPost } from "../../../Util/http";
import { addAlert } from "../../../MsgNotify/msgNotifyActions";

import Apvs from "./Apvs/apvs";
import Dokumenter from "./Apvs/dokumenter";
import Modal from "../../../Common/modal";
import Chat from "./Chat";
import UsedProducts from "./UsedProducts/usedProducts";
import SuggestSelectInput from "../../../Common/suggestSelectInput";
import {
  getUsageSuggestions,
  addUsageForWorkplace,
} from "../DailyReport/Usage/actions";

class Arbejdsmiljo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usedProductsKey: 1,
      suggiValue: { id: "", name: "" },
      showInfoWorkplace: false,
      showSafetyWorkplace: false,
      showUsageTooltip: false,
      showDocuments: false,
      showDatablade: false,
      showAPV: true,
      hide: true,
      loading: false,
      selected: {},
      apvs: [],
      document: undefined,
      employees: {},
      data: {
        name: "Dokumenter",
        root: "root",
        toggled: true,
        children: [
          {
            apv: true,
            name: "Gældende APV",
            toggled: true,
            children: [],
          },
        ],
      },
    };
    this.onToggle = this.onToggle.bind(this);
  }

  onToggle(node, toggled) {
    if (this.state.cursor) {
      this.state.cursor.active = false;
    }
    node.active = true;

    if (node.name !== "Dokumenter") {
      if (node.children) {
        node.toggled = toggled;
      }
    }

    this.setState({ cursor: node });
  }

  replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(find, "g"), replace);
  };

  componentWillMount() {
    var _url2 =
      process.env.REACT_APP_webApiEndPoint +
      "api/workplace/" +
      this.props.params.workplaceId;
    httpGet(_url2)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        this.setState({
          employees: json.employees,
        });
      });
    const _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/arbejdsmiljo/" +
      this.props.params.workplaceId +
      "/save";

    httpGet(_url)
      .then((resp) => resp.json())
      .then((json) => {
        if (!json) {
          return;
        }
        let rep = this.replaceAll(
          json.documentState,
          '"toggled": true',
          '"toggled": false'
        );
        let rep2 = this.replaceAll(rep, '"active": true', '"active": false');
        let a = JSON.parse(rep2);
        a.data.toggled = true;
        a.data.children[0].toggled = true;
        this.setState({
          selected: a.selected,
          data: a.data,
        });
        return a.selected;
      })
      .then((selected) => {
        const url = process.env.REACT_APP_webApiEndPoint + `api/apv`;
        httpGet(url)
          .then((resp) => resp.json())
          .then((apvs) => {
            let sel = [];
            let unsel = [];
            apvs.forEach((a) => {
              if (a) {
                if (a.name === "" || a.name === undefined || a.name === null) {
                } else if (selected && a.id && selected[a.id]) {
                  sel.push(a);
                } else {
                  unsel.push(a);
                }
              }
            });
            this.setState({
              apvs: sel.concat(unsel),
            });
          })
          .catch(() => {
            this.props.dispatch(addAlert("kunne ikke hente apver"));
          });
      })
      .catch((e) => {
        console.log(e);
        this.props.dispatch(addAlert("Kunne ikke hente dokumenter"));
      });
  }
  componentDidMount() {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  }
  componentDidUpdate = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  toggleApv = (apv) => {
    if (auth.getProfile().role === "Formand") {
      this.setState({
        showDocuments: true,
      });
      return;
    }

    let sel = this.state.selected;
    if (sel[apv.id]) {
      delete sel[apv.id];
      let i = null;
      this.state.data.children[0].children.forEach((c, index) => {
        if (c.id === apv.id) {
          i = index;
        }
      });
      this.state.data.children[0].children.splice(i, 1);
    } else {
      apv.apv = true;
      sel[apv.id] = apv;
      this.state.data.children[0].children.push(apv);
    }
    this.setState({
      selected: sel,
      showDocuments: true,
    });
    this.saveDocumentTree();
  };
  saveDocumentTree = () => {
    let storeObj = {
      selected: this.state.selected,
      data: this.state.data,
    };
    const _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/arbejdsmiljo/" +
      this.props.params.workplaceId +
      "/savetree?documentState=" +
      JSON.stringify(storeObj);
    httpPost(_url).catch((e) => {
      this.props.dispatch(addAlert("Kunne ikke opdatere dokumenter"));
    });
  };
  show = (node, type, value, filename) => {
    if (!type) {
      if (node.document.fileUrl.indexOf(".pdf") !== -1) {
        this.setState({
          hide: false,
          document: { url: node.document.fileUrl },
          loading: true,
        });
      } else if (
        node.document.fileUrl.indexOf(".jpg") !== -1 ||
        node.document.fileUrl.indexOf(".jpeg") !== -1 ||
        node.document.fileUrl.indexOf(".png") !== -1 ||
        node.document.fileUrl.indexOf(".gif") !== -1 ||
        node.document.fileUrl.indexOf(".tiff") !== -1
      ) {
        {
          this.setState({
            hide: false,
            document: { img: node.document.fileUrl },
          });
        }
      } else {
        window.open(node.document.fileUrl);
      }
    } else if (type === "RENAME") {
      let s = this.state.data;
      let obj = s.children[node.i];
      obj.done = false;
      obj.name = value;
      this.setState({
        data: s,
      });
    } else if (type === "RENAME_STATE") {
      let s = this.state.data;
      let obj = s.children[node.i];
      obj.done = false;
      this.setState({
        data: s,
      });
    } else if (type === "DELETE_FOLDER") {
      if (node.goahead) {
        let state = this.state.data;
        state.children.splice(node.i, 1);
        this.setState({
          data: state,
        });
        this.saveDocumentTree();
      } else {
        let state = this.state.data;
        let o = state.children[node.i];
        o.goahead = true;
        this.setState({
          data: state,
        });
      }
    } else if (type === "ANNULLER_FOLDER") {
      let state = this.state.data;
      let o = state.children[node.i];
      o.goahead = false;
      this.setState({
        data: state,
      });
    } else if (type === "DONE") {
      let s = this.state.data;
      let obj = s.children[node.i];
      obj.done = true;
      this.setState({
        data: s,
      });
      this.saveDocumentTree();
    } else if (type === "FILEUPLOAD") {
      const _url =
        process.env.REACT_APP_webApiEndPoint +
        "api/arbejdsmiljo/" +
        this.props.params.workplaceId +
        "/save";
      httpPost(_url, {
        document: {
          name: filename,
          fileUrl: value.split(",")[1],
        },
      })
        .then((resp) => resp.json())
        .then((json) => {
          let state = this.state.data;
          state.children[node.i].children.push({
            id: json.apvId,
            i: node.i,
            name: filename,
            document: {
              fileUrl: json.document.fileUrl,
            },
            toggled: true,
          });
          this.setState({
            data: state,
          });
          this.saveDocumentTree();
        })
        .catch((e) => {
          this.props.dispatch(addAlert("Kunne ikke uploade dokument"));
        });
    } else if (type === "DELETE") {
      if (node.goahead) {
        let state = this.state.data;
        let indexO = 0;
        for (
          var i = 0, len = state.children[node.i].children.length;
          i < len;
          i++
        ) {
          if (state.children[node.i].children[i].id === node.id) {
            indexO = i;
            break;
          }
        }
        state.children[node.i].children.splice(indexO, 1);
        this.setState({
          data: state,
        });
        this.saveDocumentTree();
      } else {
        let state = this.state.data;
        let indexO = 0;
        for (
          var i = 0, len = state.children[node.i].children.length;
          i < len;
          i++
        ) {
          if (state.children[node.i].children[i].id === node.id) {
            indexO = i;
            break;
          }
        }
        let o = state.children[node.i].children[indexO];
        o.goahead = true;
        this.setState({
          data: state,
        });
      }
    } else if (type === "ANNULLER") {
      if (node.goahead) {
        let state = this.state.data;
        let indexO = 0;
        for (
          var i = 0, len = state.children[node.i].children.length;
          i < len;
          i++
        ) {
          if (state.children[node.i].children[i].id === node.id) {
            indexO = i;
            break;
          }
        }
        let o = state.children[node.i].children[indexO];
        o.goahead = false;
        this.setState({
          data: state,
        });
      }
    } else if (type === "FOLDER") {
      let state = this.state.data;
      state.children.push({
        i: state.children.length,
        name: "Ny mappe",
        toggled: true,
        children: [],
      });
      this.setState({
        data: state,
      });
    } else {
    }
  };
  renderButtons = () => {
    return (
      <div style={{ height: "40" }}>
        {/* <button
          key="narved"
          className="waves-btn"
          style={[
            {
              backgroundColor: "rgb(204, 204, 204)",
              float: "right",
              border: "none",
              outline: "none",
              cursor: "pointer",
              padding: 10,
              transition: "0.3s",
              ":hover": {
                backgroundColor: "#ddd",
              },
              borderRadius: 0,
            },
          ]}
          onClick={() => this.props.openGodtSet()}
        >
          + Nærvedhændelse
        </button> */}
        {/*        <button
          key="ulykke"
          className="waves-btn"
          style={[{
            backgroundColor: 'rgb(204, 204, 204)',
            float: 'right',
            border: 'none',
            outline: 'none',
            cursor: 'pointer',
            padding: 10,
            transition: '0.3s',
            ':hover': {
              backgroundColor: '#ddd',
            },
            borderRadius: 0
          }]}
        >
          + Anmeld ulykke
      </button> */}
      </div>
    );
  };
  updateAck = (id, safety, understood) => {
    if (Object.keys(this.state.selected).length === 0) {
      alert("En funktionær skal tilknytte APV til arbejdsstedet");
    } else {
      const _url =
        process.env.REACT_APP_webApiEndPoint +
        "api/arbejdsmiljo/" +
        this.props.params.workplaceId +
        "/ack";
      httpPost(_url, {
        safety,
        understood,
        id,
      })
        .then(() => {
          this.props.updateAck(id, safety, understood);
        })
        .catch((e) => {
          this.props.dispatch(addAlert("Noget gik galt"));
        });
    }
  };

  render() {
    const { employees, suggiValue } = this.state;
    const { suggestions } = this.props;
    return (
      <div style={styles.container}>
        {!this.state.hide ? (
          <div
            style={{
              position: "absolute",
              top: -40,
              width: "100%",
              height: "105%",
            }}
          >
            <Modal
              hide={this.state.hide}
              onClose={() => {
                this.setState({ hide: !this.state.hide, document: undefined });
              }}
            >
              {this.state.loading ? (
                <i
                  style={{ color: "white" }}
                  className="fa fa-spinner fa-spin fa-3x fa-fw"
                ></i>
              ) : null}
              {this.state.document ? (
                this.state.document.img ? (
                  <img
                    key={this.state.document.img}
                    src={this.state.document.img}
                    height="auto"
                    width="auto"
                    style={{ maxHeight: "90%", maxWidth: "90%" }}
                    alt="chat"
                  ></img>
                ) : (
                  <iframe
                    title="dpdf1"
                    scrolling="no"
                    width="100%"
                    height="95%"
                    src={
                      "https://docs.google.com/viewer?url=" +
                      this.state.document.url +
                      "&embedded=true"
                    }
                    onLoad={() =>
                      this.setState({
                        loading: false,
                      })
                    }
                  ></iframe>
                )
              ) : null}
            </Modal>
          </div>
        ) : null}
        {/* content */}
        <div style={styles.contentContainer}>
          <div style={[styles.column, { width: "65%" }]}>
            <Scrollbars style={{ width: "100%", height: "100%" }}>
              <div style={{ width: "98%", height: "100%" }}>
                {this.renderButtons()}
                <div
                  style={{
                    cursor: "pointer",
                    backgroundColor: "rgb(238, 238, 238)",
                    marginTop: "15px",
                  }}
                  onClick={() =>
                    this.setState({ showAPV: !this.state.showAPV })
                  }
                >
                  <h3
                    style={{
                      textAlign: "center",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    Gældende APV
                    <i
                      style={{ paddingLeft: 10 }}
                      className={
                        this.state.showAPV
                          ? "fa fa-caret-up"
                          : "fa fa-caret-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </h3>
                </div>
                {this.state.showAPV ? (
                  <div
                    style={[
                      { border: "5px solid rgb(238, 238, 238)" },
                      auth.getProfile().role === "Formand"
                        ? null
                        : { height: 200 },
                    ]}
                  >
                    <Apvs
                      onlyShowSelected={auth.getProfile().role === "Formand"}
                      dontScroll={auth.getProfile().role === "Formand"}
                      toggleApv={this.toggleApv}
                      selected={this.state.selected}
                      apvs={this.state.apvs}
                    />
                  </div>
                ) : null}
                <div
                  style={{
                    cursor: "pointer",
                    backgroundColor: "rgb(238, 238, 238)",
                    marginTop: "15px",
                  }}
                  onClick={() =>
                    this.setState({ showDocuments: !this.state.showDocuments })
                  }
                >
                  <h3
                    style={{
                      textAlign: "center",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    Dokumenter
                    <i
                      style={{ paddingLeft: 10 }}
                      className={
                        this.state.showDocuments
                          ? "fa fa-caret-up"
                          : "fa fa-caret-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </h3>
                </div>
                {this.state.showDocuments ? (
                  <div style={{ border: "5px solid rgb(238, 238, 238)" }}>
                    <Dokumenter
                      apvs={this.state.selected}
                      data={this.state.data}
                      show={this.show}
                      onToggle={this.onToggle}
                    />
                  </div>
                ) : null}
                <div
                  style={{
                    cursor: "pointer",
                    backgroundColor: "rgb(238, 238, 238)",
                    marginTop: "15px",
                  }}
                  onClick={() =>
                    this.setState({ showDatablade: !this.state.showDatablade })
                  }
                >
                  <h3
                    style={{
                      textAlign: "center",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    Datablade for materiel / materiale
                    <i
                      style={{ paddingLeft: 10 }}
                      className={
                        this.state.showDatablade
                          ? "fa fa-caret-up"
                          : "fa fa-caret-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </h3>
                  <div style={{ position: "relative" }}>
                    <i
                      className="fa fa-info-circle"
                      aria-hidden="true"
                      style={{
                        position: "absolute",
                        bottom: 11,
                        right: 11,
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({
                          showUsageTooltip: !this.state.showUsageTooltip,
                        });
                      }}
                    ></i>
                    {this.state.showUsageTooltip ? (
                      <span
                        style={{
                          width: 158,
                          backgroundColor: "#555",
                          color: "#fff",
                          textAlign: "center",
                          borderRadius: 6,
                          padding: "5px 0",
                          position: "absolute",
                          right: 35,
                          bottom: -45,
                          transition: "opacity 1s",
                        }}
                      >
                        Her vil der løbende blive tilføjet datablade for
                        materiel og materiale brugt på arbejdsstedet
                      </span>
                    ) : null}
                  </div>
                </div>
                {this.state.showDatablade ? (
                  <div>
                    <SuggestSelectInput
                      onQuery={(value) => {
                        //
                        this.props.dispatch(
                          getUsageSuggestions("materiale", value, true)
                        );
                        console.log("its time");
                      }}
                      suggestions={suggestions}
                      placeholder="tilføj materiel / materiale"
                      onChange={(val) => {
                        //change
                        this.setState({
                          suggiValue: val,
                        });
                      }}
                      value={suggiValue}
                      inputStyle={{
                        "-webkit-appearance": "none",
                        border: "none",
                        display: "block",
                      }}
                      onBlur={(val) => {
                        // blur
                        if (this.state.suggiValue.id) {
                          this.props.dispatch(
                            addUsageForWorkplace(
                              this.props.params.workplaceId,
                              this.state.suggiValue.id,
                              () => {
                                this.setState({
                                  suggiValue: { id: null, name: "" },
                                  usedProductsKey:
                                    this.state.usedProductsKey + 1,
                                });
                              }
                            )
                          );
                        }
                      }}
                    />
                    <div style={{}}>
                      <UsedProducts
                        key={this.state.usedProductsKey}
                        workplaceId={this.props.params.workplaceId}
                        show={this.show}
                      />
                    </div>
                  </div>
                ) : null}

                <div
                  style={{
                    paddingTop: 50,
                    textAlign: "center",
                    paddingBottom: 10,
                  }}
                >
                  For at oprette dagrapporter på arbejdsstedet skal alle
                  medarbejdere bekræfte følgende:
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    height: 135,
                    paddingBottom: 50,
                  }}
                >
                  <div style={{ width: "80%", position: "relative" }}>
                    <div
                      key="f"
                      // onClick={() => {
                      //   let safety = this.props.safety
                      //   let understood = !this.props.understood
                      //   this.updateAck(safety, understood)
                      // }}
                      className={"btn btn-primary"}
                      style={[
                        {
                          width: "100%",
                          float: "left",
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          transition: "0.3s",
                          borderRadius: 0,
                          ":hover": {
                            backgroundColor: "#385C70",
                          },
                        },
                      ]}
                    >
                      <div>Jeg har læst og forstået arbejdsopgaven</div>
                    </div>
                    <i
                      style={{
                        position: "absolute",
                        top: 11,
                        right: -35,
                        cursor: "pointer",
                      }}
                      className="fa  fa-question-circle"
                      aria-hidden="true"
                      onClick={() => {
                        this.setState({
                          showInfoWorkplace: !this.state.showInfoWorkplace,
                        });
                      }}
                    ></i>
                    {this.state.showInfoWorkplace ? (
                      <span
                        style={{
                          width: 158,
                          backgroundColor: "#555",
                          color: "#fff",
                          textAlign: "center",
                          borderRadius: 6,
                          padding: "5px 0",
                          position: "absolute",
                          right: -10,
                          bottom: -22,
                          transition: "opacity 1s",
                          zIndex: 999,
                          textIndent: 1,
                        }}
                      >
                        I fanen OVERSIGT, finder du information omkring
                        arbejdsstedet
                      </span>
                    ) : null}
                  </div>
                  <div style={{ width: "80%", position: "relative" }}>
                    <div
                      key="l"
                      // onClick={() => {
                      //   let safety = !this.props.safety
                      //   let understood = this.props.understood
                      //   this.updateAck(safety, understood)
                      // }}
                      className={"btn btn-success"}
                      style={[
                        {
                          width: "93%",
                          float: "left",
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          transition: "0.3s",
                          borderRadius: 0,
                          ":hover": {
                            backgroundColor: "#15B597",
                          },
                        },
                      ]}
                    >
                      Jeg har modtaget sikkerhedsinstruktioner
                    </div>
                    <div
                      key="wql"
                      className={"btn btn-primary"}
                      style={[
                        {
                          width: "7%",
                          float: "right",
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          transition: "0.3s",
                          borderRadius: 0,
                          ":hover": {
                            backgroundColor: "#385C70",
                          },
                        },
                      ]}
                    ></div>
                    <i
                      style={{
                        position: "absolute",
                        top: 11,
                        right: -35,
                        cursor: "pointer",
                      }}
                      className="fa  fa-question-circle"
                      aria-hidden="true"
                      onClick={() => {
                        this.setState({
                          showSafetyWorkplace: !this.state.showSafetyWorkplace,
                        });
                      }}
                    ></i>
                    {this.state.showSafetyWorkplace ? (
                      <span
                        style={{
                          width: 300,
                          backgroundColor: "#555",
                          color: "#fff",
                          textAlign: "center",
                          borderRadius: 6,
                          padding: "5px 0",
                          position: "absolute",
                          right: -10,
                          bottom: -22,
                          transition: "opacity 1s",
                          zIndex: 999,
                          textIndent: 1,
                        }}
                      >
                        <p>
                          Her på siden finder du den gældende
                          arbejdspladsvurdering
                        </p>
                        <p>
                          I sektionen Dokumenter kan du åbne og læse APV'er og
                          andet relevant materiale ved at klikke på ikonet{" "}
                          <i className="fa  fa-search" aria-hidden="true" />{" "}
                        </p>
                      </span>
                    ) : null}
                  </div>
                  <div style={{ paddingTop: 10 }}></div>

                  {Object.values(employees).map((e, idx) => {
                    const id = e ? (e.id ? e.id.toLowerCase() : "") : "";
                    let user = {};
                    if (this.props.userAcks) {
                      user = this.props.userAcks[id];
                    }
                    return (
                      <div
                        key={idx}
                        style={{
                          width: "80%",
                          position: "relative",
                          backgroundColor: "rgb(238, 238, 238)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                          }}
                        >
                          <div
                            style={{
                              width: "86%",
                              textIndent: 15,
                              alignSelf: "center",
                            }}
                          >
                            {e.name}
                          </div>
                          <div
                            onClick={() => {
                              if (this.props.userAcks) {
                                // let safety = !this.props.safety
                                // let understood = this.props.understood
                                if (user) {
                                  this.updateAck(
                                    id,
                                    user ? !user.safety : true,
                                    user ? user.understood : false
                                  );
                                }
                              }
                            }}
                            className="btn btn-success waves-btn"
                            style={{ width: "7%", borderRadius: 0 }}
                          >
                            {user ? (
                              user.safety ? (
                                <i
                                  style={{
                                    position: "absolute",
                                    top: 12,
                                    right: 10,
                                  }}
                                  className="fa fa-check-square-o"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i
                                  style={{
                                    position: "absolute",
                                    top: 12,
                                    right: 12,
                                  }}
                                  className="fa fa-square-o"
                                  aria-hidden="true"
                                ></i>
                              )
                            ) : (
                              <i
                                style={{
                                  position: "absolute",
                                  top: 12,
                                  right: 12,
                                }}
                                className="fa fa-square-o"
                                aria-hidden="true"
                              ></i>
                            )}
                          </div>
                          <div
                            onClick={() => {
                              // let safety = !this.props.safety
                              // let understood = this.props.understood
                              this.updateAck(
                                id,
                                user ? user.safety : false,
                                user ? !user.understood : true
                              );
                            }}
                            className="btn btn-primary waves-btn"
                            style={{ width: "7%", borderRadius: 0 }}
                          >
                            {user ? (
                              user.understood ? (
                                <i
                                  style={{
                                    position: "absolute",
                                    top: 12,
                                    right: 10,
                                  }}
                                  className="fa fa-check-square-o"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i
                                  style={{
                                    position: "absolute",
                                    top: 12,
                                    right: 12,
                                  }}
                                  className="fa fa-square-o"
                                  aria-hidden="true"
                                ></i>
                              )
                            ) : (
                              <i
                                style={{
                                  position: "absolute",
                                  top: 12,
                                  right: 12,
                                }}
                                className="fa fa-square-o"
                                aria-hidden="true"
                              ></i>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Scrollbars>
          </div>
          <div style={[styles.column, { width: "0.67%" }]}></div>
          <div style={[styles.column, { width: "34.33%", paddingTop: "20px" }]}>
            <h3 style={{ textAlign: "center", padding: 10 }}>
              Tilføjelser til APV
            </h3>
            <div
              style={{
                paddingTop: 5,
                paddingLeft: 20,
                paddingRight: 20,
                paddingBottom: 10,
                marginBottom: 10,
                fontSize: 15,
                backgroundColor: "antiquewhite",
                width: "98%",
              }}
            >
              <div>
                Er dine{" "}
                <span
                  style={{
                    color: "#dc3545",
                    fontWeight: 900,
                    fontSize: 14,
                    animation: "shake 1.2s",
                    display: "inline-block",
                  }}
                >
                  ADGANGSVEJE
                </span>{" "}
                ok på byggepladsen ?{" "}
              </div>
              <div> Tag et billede og skriv en beskrivende tekst nedenfor</div>
            </div>
            <Scrollbars style={{ width: "100%", height: "100%" }}>
              <div style={{ width: "98%", height: "100%" }}>
                <Chat
                  activityId={this.props.params.workplaceId}
                  show={this.show}
                />
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    width: "100%",
    height: "100%",
    position: "relative",
    display: "flex",
    "@media (min-width: 1200px)": {
      position: "relative",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: "1170px",
      width: "100%",
    },
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingTop: 5,
  },
  column: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "100%",
  },
  border: {
    border: "2px solid lightgrey",
  },
};

const selectProps = (state) => {
  return {
    ...state.arbejdsmiljoReducer,
    ...state.dailyReportUsageReducer,
  };
};

export default connect(selectProps)(Radium(Arbejdsmiljo));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Arbejdsmiljo/index.js